import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import { fromJS } from 'immutable';
import * as _ from 'lodash';
import validator from 'validator';
import ReactResizeDetector from 'react-resize-detector';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import injectReducer from 'utils/injectReducer';
import { makeSelectStepOther, makeSelectStepOtherErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  handleFormDataChange,
  nextSlide,
  resetFormData,
  resetSubBenefit,
  resetBenefitOther,
  resetFormRepatriationExpenses,
  resetFormBurialExpenses,
  resetFormAccidentalDeathAndDismemberment,
  resetFormPersonalLiability,
  resetFormPersonalAccident,
  resetFormLossOfIncome,
  resetFormTotalPermanentDisablement,
  resetFormLossOfLife,
} from './actions';
import OptionsContainer from '../components/OptionsContainer';
import { ErrorMessage, Validate, ValidateGroup } from '../../../components/Validation';
import { saveFormData, emailMedicalADDDocument } from '../actions';
import ExpenseClaimForm from './components/OtherExpenseClaimForm/index';
import { AdditionalList } from './components/Additional';
import { AdditionalListExpense } from './components/AdditionalExpense';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import AsyncButtonSendMail from '../../../components/AsyncButtonSendMail/index';
import { stepOtherExpenseLookup } from '../../FastCover/dataMapper/claimCodeMapper';
import HelpText from '../../../components/HelpText';
import Textbox from '../components/Textbox';
import { required, checkDateOnly } from '../../../utils/validation/validator';
import DatePicker from '../components/DatePicker';
import TextArea from '../components/TextArea';
import CurrencySelector from '../components/CurrencySelector';
import { makeSelectJSONVersion } from '../../App/selectors';
import { makeSelectInsuredsList, makeSelectIsClaimForFieldEnabled, makeSelectPolicyTypeCode } from '../../App/selectors';
import { POLICY_TYPE } from 'containers/FastCover/constants';

export class StepOther extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
      physicianEmail: false,
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = _.uniqueId();
    this.emailMeDocumentButton = _.uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    const propertyFullName = `form.${propertyName}`;
    if (event === null) {
      this.props.onFormDataChange(propertyFullName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyFullName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyFullName, value);
    }
    // this.props.makeDirty(10);
  };

  onExpansesClaimedChange = (field, data) => {
    this.props.onFormDataChange(`form.${field}`, fromJS(data));
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  // Other SCTI
  onPersonalLiabilityChange = (data) => {
    this.props.onFormDataChange('form.infoPersonalLiabilityItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onLossOfIncomeChange = (data) => {
    this.props.onFormDataChange('form.infoLossOfIncomeItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onTotalPermanentDisablementChange = (data) => {
    this.props.onFormDataChange('form.infoTotalPermanentDisablementItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onLossOfLifeChange = (data) => {
    this.props.onFormDataChange('form.infoLossOfLifeItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onPersonalAccidentChange = (data) => {
    this.props.onFormDataChange('form.infoPersonalAccidentItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onResize() {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  }

  getValidationErrors() {
    const {
      isThereAnyThingElseYouWouldLikeToClaimFor,
      areYouClaimingForPersonalLiability,
      areYouClaimingForGolfPackOptionalCover,
      areYouClaimingForBicyclePackOptionalCover,
      expensesClaimed,
    } = this.props.form;
    const errors = [];

    if (
      (areYouClaimingForGolfPackOptionalCover === 'true' ||
        areYouClaimingForBicyclePackOptionalCover === 'true' ||
        areYouClaimingForPersonalLiability === 'true' || isThereAnyThingElseYouWouldLikeToClaimFor === 'true')
    ) {
      if (this.validateTableField(expensesClaimed)) {
        errors.push({
          field: 'expensesClaimed',
          message: 'Costs Claimed table fields are required fields.',
        });
      }
    }

    return errors;
  }

  handlePersonalLiabilityExpensesSelected = (propertyName) => (event) => {
    const { whatExpensesAreYouClaimingFor } = this.props.form;
    const expensesSelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
      ? whatExpensesAreYouClaimingFor.toJS()
      : whatExpensesAreYouClaimingFor || [];
    const listChecked = _.cloneDeep(expensesSelected);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
      switch (name) {
        case 'Personal Liability':
          this.props.onResetFormPersonalLiability();
          break;
        case 'Personal Accident':
          this.props.onResetFormPersonalAccident();
          break;
        default:
          break;
      }
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handlePersonalAccidentExpensesSelected = (propertyName) => (event) => {
    const { whatAreYourExpensesRelatedTo } = this.props.form;
    const expensesSelected = !!whatAreYourExpensesRelatedTo && typeof whatAreYourExpensesRelatedTo.toJS === 'function'
      ? whatAreYourExpensesRelatedTo.toJS()
      : whatAreYourExpensesRelatedTo || [];
    const listChecked = _.cloneDeep(expensesSelected);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
      switch (name) {
        case 'Loss of Income':
          this.props.onResetFormLossOfIncome();
          break;
        case 'Total permanent disablement':
          this.props.onResetFormTotalPermanentDisablement();
          break;
        case 'Loss of Life':
          this.props.onResetFormLossOfLife();
          break;
        default:
          break;
      }
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  handleEmailMeButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.sendPhysicianEmail();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const {
      areYouClaimingForPersonalLiability,
      isThereAnyThingElseYouWouldLikeToClaimFor,
      areYouClaimingForAccidentalDeathAndDismemberment,
      areYouClaimingForRepatriationExpenses,
      areYouClaimingForBurialExpenses,
      infoPersonalLiabilityItems = [],
      infoLossOfIncomeItems = [],
      infoTotalPermanentDisablementItems = [],
      infoLossOfLifeItems = [],
      infoPersonalAccidentItems = [],
    } = this.props.form;
    const isSelectBenefitSCTI = infoPersonalLiabilityItems.length > 0 || infoLossOfIncomeItems.length > 0 || infoTotalPermanentDisablementItems.length > 0 || infoLossOfLifeItems.length > 0 || infoPersonalAccidentItems.length > 0;
    const isSelectBenefit = areYouClaimingForPersonalLiability === 'true'
      || isThereAnyThingElseYouWouldLikeToClaimFor === 'true'
      || areYouClaimingForAccidentalDeathAndDismemberment === 'true'
      || areYouClaimingForRepatriationExpenses === 'true'
      || areYouClaimingForBurialExpenses === 'true'
      || isSelectBenefitSCTI;
    const valid = isSelectBenefit && this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
    // this.props.makeDirty(10);
  };

  handleChangeAmount = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^\d*(\.\d{0,2})?$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value)) {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleDayChange = (propertyName) => (day) => {
    const localDate = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, localDate);
    // this.props.makeDirty(10);
  };

  handleChangeNameOfDeceased = (propertyName) => (event) => {
    const { checkNameOfDeceased } = this.props.form;
    const checkNameOfDeceases = !!checkNameOfDeceased && typeof checkNameOfDeceased.toJS === 'function'
      ? checkNameOfDeceased.toJS()
      : checkNameOfDeceased || [];

    const listChecked = _.cloneDeep(checkNameOfDeceases);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleCurrencyChange = (propertyName) => (value) => {
    this.props.onFormDataChange(propertyName, value);
  }

  handleNext = () => {
    const {
      areYouClaimingForPersonalLiability,
      isThereAnyThingElseYouWouldLikeToClaimFor,
      areYouClaimingForAccidentalDeathAndDismemberment,
      areYouClaimingForRepatriationExpenses,
      areYouClaimingForBurialExpenses,
    } = this.props.form;
    const isSelectBenefit = areYouClaimingForPersonalLiability === 'true'
      || isThereAnyThingElseYouWouldLikeToClaimFor === 'true'
      || areYouClaimingForAccidentalDeathAndDismemberment === 'true'
      || areYouClaimingForRepatriationExpenses === 'true'
      || areYouClaimingForBurialExpenses === 'true';
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = isSelectBenefit && this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    setTimeout(() => {
      this.props.onFormDataSave();
    });
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  renderYouClaimingForAccidentalDeathAndDismemberment() {
    const { isSummary, submitted, jsonVersion } = this.props;
    const {
      areYouClaimingForAccidentalDeathAndDismemberment,
      nameOfDeceased,
      dateOfInjury,
      theClaimIsBeingMadeUnder,
      placeWhereAccidentHappened,
      describeWhereTheAccidentOccurred,
      describeHowTheAccidentOccurred,
      checkNameOfDeceased,
      enableTime,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const buttonEmailMeDisable = !!enableTime && new Date().getTime() < enableTime;
    const checkNameOfDeceases = !!checkNameOfDeceased && typeof checkNameOfDeceased.toJS === 'function'
      ? checkNameOfDeceased.toJS()
      : checkNameOfDeceased || [];
    const newVersion = jsonVersion > 7;

    const isReadOnly = submitted || isSummary;
    return (
      areYouClaimingForAccidentalDeathAndDismemberment === 'true' && (
        <div className={'ml-3'}>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="nameOfDeceased"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={nameOfDeceased}
                fieldName={messages.nameOfDeceased}
              >
                <Textbox
                  name="nameOfDeceased"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.nameOfDeceased')}
                  value={nameOfDeceased}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.nameOfDeceased}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="theClaimIsBeingMadeUnder"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={theClaimIsBeingMadeUnder}
                fieldName={messages.theClaimIsBeingMadeUnder}
              >
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="Accidental Death"
                      checked={theClaimIsBeingMadeUnder === 'Accidental Death'}
                      onChange={this.handleChange('form.theClaimIsBeingMadeUnder')}
                    />
                    <FormattedMessage {...messages.accidentalDeath} />
                  </OptionsContainer>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="Accidental Dismemberment"
                      checked={theClaimIsBeingMadeUnder === 'Accidental Dismemberment'}
                      onChange={this.handleChange('form.theClaimIsBeingMadeUnder')}
                    />
                    <FormattedMessage {...messages.accidentalDismemberment} />
                  </OptionsContainer>
                </FlexBox>
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.theClaimIsBeingMadeUnder}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="dateOfInjury"
                validators={[checkDateOnly, required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={dateOfInjury}
                fieldName={messages.dateOfInjury}
              >
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateOfInjury"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateOfInjury')}
                  value={dateOfInjury}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.dateOfDeath}
                  />
                </ErrorMessage>
                <ErrorMessage for="checkDateOnly">
                  <FormattedMessage
                    {...messages.checkEventDate}
                    values={messages.dateOfInjury}
                  />
                </ErrorMessage>
              </Validate>
              <div className={'pt-3'}></div>
              <Validate
                name="placeWhereAccidentHappened"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={placeWhereAccidentHappened}
                fieldName={messages.placeWhereAccidentHappened}
              >
                <Textbox
                  name="placeWhereAccidentHappened"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.placeWhereAccidentHappened')}
                  value={placeWhereAccidentHappened}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.placeWhereAccidentHappened}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            {theClaimIsBeingMadeUnder !== 'Accidental Dismemberment' &&
              <div className={'form-group col-sm-6'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.checkNameOfDeceased} />
                </PageSectionHeader>
                <div className={'row'}>
                  <div className={'form-group col-sm-6'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="Right Hand"
                      checked={checkNameOfDeceases.includes('Right Hand')}
                      onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                    />
                    <span>
                      <FormattedMessage {...messages.rightHand} />
                    </span>
                  </div>
                  <div className={'form-group col-sm-6'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="Both Feet"
                      checked={checkNameOfDeceases.includes('Both Feet')}
                      onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                    />
                    <span>
                      <FormattedMessage {...messages.bothFeet} />
                    </span>
                  </div>
                  <div className={'form-group col-sm-6'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="Left Hand"
                      checked={checkNameOfDeceases.includes('Left Hand')}
                      onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                    />
                    <span>
                      <FormattedMessage {...messages.leftHand} />
                    </span>
                  </div>
                  <div className={'form-group col-sm-6'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="Sight of Right Eye"
                      checked={checkNameOfDeceases.includes('Sight of Right Eye')}
                      onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                    />
                    <span>
                      <FormattedMessage {...messages.sightOfRightEye} />
                    </span>
                  </div>
                  <div className={'form-group col-sm-6'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="Both Hands"
                      checked={checkNameOfDeceases.includes('Both Hands')}
                      onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                    />
                    <span>
                      <FormattedMessage {...messages.bothHands} />
                    </span>
                  </div>
                  <div className={'form-group col-sm-6'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="Sight of Left Eye"
                      checked={checkNameOfDeceases.includes('Sight of Left Eye')}
                      onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                    />
                    <span>
                      <FormattedMessage {...messages.sightOfLeftEye} />
                    </span>
                  </div>
                  <div className={'form-group col-sm-6'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="Right Foot"
                      checked={checkNameOfDeceases.includes('Right Foot')}
                      onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                    />
                    <span>
                      <FormattedMessage {...messages.rightFoot} />
                    </span>
                  </div>
                  <div className={'form-group col-sm-6'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="Sight Of Both Eyes"
                      checked={checkNameOfDeceases.includes('Sight Of Both Eyes')}
                      onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                    />
                    <span>
                      <FormattedMessage {...messages.sightOfBothEyes} />
                    </span>
                  </div>
                  <div className={'form-group col-sm-6'}>
                    <input
                      disabled={isReadOnly}
                      type="checkbox"
                      name="Left Foot"
                      checked={checkNameOfDeceases.includes('Left Foot')}
                      onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                    />
                    <span>
                      <FormattedMessage {...messages.leftFoot} />
                    </span>
                  </div>
                </div>
              </div>}
            {theClaimIsBeingMadeUnder === 'Accidental Dismemberment' &&
              <div className={'form-group col-sm-6'}>
                <Validate
                  name="checkNameOfDeceased"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={checkNameOfDeceases}
                  fieldName={messages.checkNameOfDeceased}
                >
                  <div className={'row'}>
                    <div className={'form-group col-sm-6'}>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Right Hand"
                        checked={checkNameOfDeceases.includes('Right Hand')}
                        onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                      />
                      <span>
                        <FormattedMessage {...messages.rightHand} />
                      </span>
                    </div>
                    <div className={'form-group col-sm-6'}>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Both Feet"
                        checked={checkNameOfDeceases.includes('Both Feet')}
                        onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                      />
                      <span>
                        <FormattedMessage {...messages.bothFeet} />
                      </span>
                    </div>
                    <div className={'form-group col-sm-6'}>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Left Hand"
                        checked={checkNameOfDeceases.includes('Left Hand')}
                        onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                      />
                      <span>
                        <FormattedMessage {...messages.leftHand} />
                      </span>
                    </div>
                    <div className={'form-group col-sm-6'}>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Sight of Right Eye"
                        checked={checkNameOfDeceases.includes('Sight of Right Eye')}
                        onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                      />
                      <span>
                        <FormattedMessage {...messages.sightOfRightEye} />
                      </span>
                    </div>
                    <div className={'form-group col-sm-6'}>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Both Hands"
                        checked={checkNameOfDeceases.includes('Both Hands')}
                        onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                      />
                      <span>
                        <FormattedMessage {...messages.bothHands} />
                      </span>
                    </div>
                    <div className={'form-group col-sm-6'}>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Sight of Left Eye"
                        checked={checkNameOfDeceases.includes('Sight of Left Eye')}
                        onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                      />
                      <span>
                        <FormattedMessage {...messages.sightOfLeftEye} />
                      </span>
                    </div>
                    <div className={'form-group col-sm-6'}>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Right Foot"
                        checked={checkNameOfDeceases.includes('Right Foot')}
                        onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                      />
                      <span>
                        <FormattedMessage {...messages.rightFoot} />
                      </span>
                    </div>
                    <div className={'form-group col-sm-6'}>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Sight Of Both Eyes"
                        checked={checkNameOfDeceases.includes('Sight Of Both Eyes')}
                        onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                      />
                      <span>
                        <FormattedMessage {...messages.sightOfBothEyes} />
                      </span>
                    </div>
                    <div className={'form-group col-sm-6'}>
                      <input
                        disabled={isReadOnly}
                        type="checkbox"
                        name="Left Foot"
                        checked={checkNameOfDeceases.includes('Left Foot')}
                        onChange={this.handleChangeNameOfDeceased('form.checkNameOfDeceased')}
                      />
                      <span>
                        <FormattedMessage {...messages.leftFoot} />
                      </span>
                    </div>
                  </div>
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.checkNameOfDeceased}
                    />
                  </ErrorMessage>
                </Validate>
              </div>}
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-12'}>
              <Validate
                name="describeWhereTheAccidentOccurred"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={describeWhereTheAccidentOccurred}
                fieldName={messages.describeWhereTheAccidentOccurred}
              >
                <TextArea
                  disabled={isReadOnly}
                  name="describeWhereTheAccidentOccurred"
                  type="text"
                  onChange={this.handleChange('form.describeWhereTheAccidentOccurred')}
                  value={describeWhereTheAccidentOccurred}
                  isSummary={isSummary}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.describeWhereTheAccidentOccurred}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-12'}>
              <Validate
                name="describeHowTheAccidentOccurred"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={describeHowTheAccidentOccurred}
                fieldName={messages.describeHowTheAccidentOccurred}
              >
                <TextArea
                  disabled={isReadOnly}
                  name="describeHowTheAccidentOccurred"
                  type="text"
                  onChange={this.handleChange('form.describeHowTheAccidentOccurred')}
                  value={describeHowTheAccidentOccurred}
                  isSummary={isSummary}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.describeHowTheAccidentOccurred}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          {newVersion !== true &&
            <div className={'row'}>
              <div className={'form-group col-sm-7'}>
                <HelpText>
                  On clicking the button an email with the Statement of Attending Physician will be sent to you. Once sent please check your email.
                </HelpText>
              </div>
              <div className={'form-group col-sm-5'}>
                <AsyncButtonSendMail
                  id={this.emailMeDocumentButton}
                  className={buttonEmailMeDisable ? 'btn-action-success' : 'btn-authentication'}
                  disabled={buttonEmailMeDisable || isReadOnly}
                  loading={this.props.loading}
                  spinner={this.showSpinnerForElement(this.emailMeDocumentButton)}
                  onClick={this.handleEmailMeButtonClick}
                >
                  Statement of Attending Physician
                </AsyncButtonSendMail>
              </div>
            </div>
          }
        </div>
      )
    );
  }

  renderYouClaimingForRepatriationExpenses() {
    const { isSummary, submitted } = this.props;
    const {
      areYouClaimingForRepatriationExpenses,
      assistance,
      dateApproved,
      causeOfDeath,
      dateOfDeath,
      stateOfDeath,
      countryOfDeath,
      wasTheMemberHospitalized,
      fromDate,
      toDate,
      nameOfFuneralServiceProvider,
      costOfLocalBurial,
      invoice,
      amountClaimed,
      costOfLocalBurialCurrency,
      amountClaimedCurrency,
      familyMemberProvidingInformation,
      relationshipToMember,
      address,
      cityOrTown,
      country,
      postalCode,
      phoneNumber,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;

    const isReadOnly = submitted || isSummary;
    return (
      areYouClaimingForRepatriationExpenses === 'true' && (
        <div className={'ml-3'}>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="assistance"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={assistance}
                fieldName={messages.assistance}
              >
                <Textbox
                  name="assistance"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.assistance')}
                  value={assistance}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.assistance}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-6'}>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="dateApproved"
                validators={[checkDateOnly, required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={dateApproved}
                fieldName={messages.dateApproved}
              >
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateApproved"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateApproved')}
                  value={dateApproved}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.dateApproved}
                  />
                </ErrorMessage>
                <ErrorMessage for="checkDateOnly">
                  <FormattedMessage
                    {...messages.checkEventDate}
                    values={messages.dateApproved}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-6'}>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-12'}>
              <Validate
                name="causeOfDeath"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={causeOfDeath}
                fieldName={messages.causeOfDeath}
              >
                <TextArea
                  disabled={isReadOnly}
                  name="causeOfDeath"
                  type="text"
                  onChange={this.handleChange('form.causeOfDeath')}
                  value={causeOfDeath}
                  isSummary={isSummary}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.causeOfDeath}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-4'}>
              <Validate
                name="dateOfDeath"
                validators={[checkDateOnly, required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={dateOfDeath}
                fieldName={messages.dateOfDeath}
              >
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateOfDeath"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateOfDeath')}
                  value={dateOfDeath}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.dateOfDeath}
                  />
                </ErrorMessage>
                <ErrorMessage for="checkDateOnly">
                  <FormattedMessage
                    {...messages.checkEventDate}
                    values={messages.dateOfDeath}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-4'}>
              <Validate
                name="stateOfDeath"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={stateOfDeath}
                fieldName={messages.stateOfDeath}
              >
                <Textbox
                  name="stateOfDeath"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.stateOfDeath')}
                  value={stateOfDeath}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.stateOfDeath}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-4'}>
              <Validate
                name="countryOfDeath"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={countryOfDeath}
                fieldName={messages.countryOfDeath}
              >
                <Textbox
                  name="countryOfDeath"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.countryOfDeath')}
                  value={countryOfDeath}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.countryOfDeath}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-4'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.wasTheMemberHospitalized} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={wasTheMemberHospitalized === 'true'}
                    onChange={this.handleChange('form.wasTheMemberHospitalized')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={wasTheMemberHospitalized === 'false'}
                    onChange={this.handleChange('form.wasTheMemberHospitalized')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
            {wasTheMemberHospitalized === 'true' && (
              <div className={'form-group col-sm-8'}>
                <div className={'row'}>
                  <div className={'form-group col-sm-6'}>
                    <Validate
                      name="fromDate"
                      validators={[checkDateOnly, required]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={fromDate}
                      fieldName={messages.from}
                    >
                      <DatePicker
                        position={'bottom-start'}
                        disabled={isReadOnly}
                        name="fromDate"
                        type="text"
                        onDayChange={this.handleDayChange('form.fromDate')}
                        value={fromDate}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.from}
                        />
                      </ErrorMessage>
                      <ErrorMessage for="checkDateOnly">
                        <FormattedMessage
                          {...messages.checkEventDate}
                          values={messages.from}
                        />
                      </ErrorMessage>
                    </Validate>
                  </div>
                  <div className={'form-group col-sm-6'}>
                    <Validate
                      name="toDate"
                      validators={[required]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={toDate}
                      fieldName={messages.to}
                    >
                      <DatePicker
                        position={'bottom-start'}
                        disabled={isReadOnly}
                        name="toDate"
                        type="text"
                        onDayChange={this.handleDayChange('form.toDate')}
                        value={toDate}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.to}
                        />
                      </ErrorMessage>
                    </Validate>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="nameOfFuneralServiceProvider"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={nameOfFuneralServiceProvider}
                fieldName={messages.nameOfFuneralServiceProvider}
              >
                <Textbox
                  name="nameOfFuneralServiceProvider"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.nameOfFuneralServiceProvider')}
                  value={nameOfFuneralServiceProvider}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.nameOfFuneralServiceProvider}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-6'}>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="costOfLocalBurial"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={costOfLocalBurial}
                fieldName={messages.costOfLocalBurial}
              >
                <Textbox
                  name="costOfLocalBurial"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChangeAmount('form.costOfLocalBurial')}
                  value={costOfLocalBurial}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.costOfLocalBurial}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="costOfLocalBurialCurrency"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={costOfLocalBurialCurrency}
                fieldName={messages.currency}
              >
                <CurrencySelector
                  name="costOfLocalBurialCurrency"
                  disabled={isReadOnly}
                  value={costOfLocalBurialCurrency}
                  onChange={this.handleCurrencyChange('form.costOfLocalBurialCurrency')}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.currency}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="invoice"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={invoice}
                fieldName={messages.invoiceNumber}
              >
                <Textbox
                  name="invoice"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.invoice')}
                  value={invoice}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.invoiceNumber}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-6'}>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="amountClaimed"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={amountClaimed}
                fieldName={messages.amountClaimed}
              >
                <Textbox
                  name="amountClaimed"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChangeAmount('form.amountClaimed')}
                  value={amountClaimed}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.amountClaimed}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="amountClaimedCurrency"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={amountClaimedCurrency}
                fieldName={messages.currency}
              >
                <CurrencySelector
                  name="amountClaimedCurrency"
                  disabled={isReadOnly}
                  value={amountClaimedCurrency}
                  onChange={this.handleCurrencyChange('form.amountClaimedCurrency')}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.currency}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="familyMemberProvidingInformation"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={familyMemberProvidingInformation}
                fieldName={messages.familyMemberProvidingInformation}
              >
                <Textbox
                  name="familyMemberProvidingInformation"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.familyMemberProvidingInformation')}
                  value={familyMemberProvidingInformation}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.familyMemberProvidingInformation}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="relationshipToMember"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={relationshipToMember}
                fieldName={messages.relationshipToMember}
              >
                <Textbox
                  name="relationshipToMember"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.relationshipToMember')}
                  value={relationshipToMember}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.relationshipToMember}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-12'}>
              <Validate
                name="address"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={address}
                fieldName={messages.address}
              >
                <Textbox
                  name="address"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.address')}
                  value={address}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.address}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-4'}>
              <Validate
                name="cityOrTown"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={cityOrTown}
                fieldName={messages.cityOrTown}
              >
                <Textbox
                  name="cityOrTown"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.cityOrTown')}
                  value={cityOrTown}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.cityOrTown}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-4'}>
              <Validate
                name="country"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={country}
                fieldName={messages.country}
              >
                <Textbox
                  name="country"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.country')}
                  value={country}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.country}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-4'}>
              <Validate
                name="postalCode"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={postalCode}
                fieldName={messages.postalCode}
              >
                <Textbox
                  name="postalCode"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.postalCode')}
                  value={postalCode}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.postalCode}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="phoneNumber"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={phoneNumber}
                fieldName={messages.phoneNumber}
              >
                <Textbox
                  name="postalCode"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChangePhoneNumber('form.phoneNumber')}
                  value={phoneNumber}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.phoneNumber}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-6'}>
            </div>
          </div>
        </div>
      )
    );
  }

  renderYouClaimingForBurialExpenses() {
    const { isSummary, submitted } = this.props;
    const {
      areYouClaimingForBurialExpenses,
      assistanceForBurial,
      dateApprovedForBurial,
      causeOfDeathForBurial,
      dateOfDeathForBurial,
      stateOfDeathForBurial,
      countryOfDeathForBurial,
      wasTheMemberHospitalizedForBurial,
      fromDateForBurial,
      toDateForBurial,
      nameOfFuneralServiceProviderForBurial,
      costOfLocalBurialForBurial,
      invoiceForBurial,
      amountClaimedForBurial,
      costOfLocalBurialCurrencyForBurial,
      amountClaimedCurrencyForBurial,
      familyMemberProvidingInformationForBurial,
      relationshipToMemberForBurial,
      addressForBurial,
      cityOrTownForBurial,
      countryForBurial,
      postalCodeForBurial,
      phoneNumberForBurial,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;

    const isReadOnly = submitted || isSummary;
    return (
      areYouClaimingForBurialExpenses === 'true' && (
        <div className={'ml-3'}>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="assistance"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={assistanceForBurial}
                fieldName={messages.assistance}
              >
                <Textbox
                  name="assistanceForBurial"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.assistanceForBurial')}
                  value={assistanceForBurial}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.assistance}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-6'}>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="dateApprovedForBurial"
                validators={[checkDateOnly, required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={dateApprovedForBurial}
                fieldName={messages.dateApproved}
              >
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateApproved"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateApprovedForBurial')}
                  value={dateApprovedForBurial}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.dateApproved}
                  />
                </ErrorMessage>
                <ErrorMessage for="checkDateOnly">
                  <FormattedMessage
                    {...messages.checkEventDate}
                    values={messages.dateApproved}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-6'}>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-12'}>
              <Validate
                name="causeOfDeath"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={causeOfDeathForBurial}
                fieldName={messages.causeOfDeath}
              >
                <TextArea
                  disabled={isReadOnly}
                  name="causeOfDeathForBurial"
                  type="text"
                  onChange={this.handleChange('form.causeOfDeathForBurial')}
                  value={causeOfDeathForBurial}
                  isSummary={isSummary}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.causeOfDeath}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-4'}>
              <Validate
                name="dateOfDeath"
                validators={[checkDateOnly, required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={dateOfDeathForBurial}
                fieldName={messages.dateOfDeath}
              >
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateOfDeathForBurial"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateOfDeathForBurial')}
                  value={dateOfDeathForBurial}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.dateOfDeath}
                  />
                </ErrorMessage>
                <ErrorMessage for="checkDateOnly">
                  <FormattedMessage
                    {...messages.checkEventDate}
                    values={messages.dateOfDeath}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-4'}>
              <Validate
                name="stateOfDeathForBurial"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={stateOfDeathForBurial}
                fieldName={messages.stateOfDeath}
              >
                <Textbox
                  name="stateOfDeath"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.stateOfDeathForBurial')}
                  value={stateOfDeathForBurial}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.stateOfDeath}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-4'}>
              <Validate
                name="countryOfDeathForBurial"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={countryOfDeathForBurial}
                fieldName={messages.countryOfDeath}
              >
                <Textbox
                  name="countryOfDeathForBurial"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.countryOfDeathForBurial')}
                  value={countryOfDeathForBurial}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.countryOfDeath}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-4'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.wasTheMemberHospitalized} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={wasTheMemberHospitalizedForBurial === 'true'}
                    onChange={this.handleChange('form.wasTheMemberHospitalizedForBurial')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={wasTheMemberHospitalizedForBurial === 'false'}
                    onChange={this.handleChange('form.wasTheMemberHospitalizedForBurial')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
            {wasTheMemberHospitalizedForBurial === 'true' && (
              <div className={'form-group col-sm-8'}>
                <div className={'row'}>
                  <div className={'form-group col-sm-6'}>
                    <Validate
                      name="fromDateForBurial"
                      validators={[checkDateOnly, required]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={fromDateForBurial}
                      fieldName={messages.from}
                    >
                      <DatePicker
                        position={'bottom-start'}
                        disabled={isReadOnly}
                        name="fromDateForBurial"
                        type="text"
                        onDayChange={this.handleDayChange('form.fromDateForBurial')}
                        value={fromDateForBurial}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.from}
                        />
                      </ErrorMessage>
                      <ErrorMessage for="checkDateOnly">
                        <FormattedMessage
                          {...messages.checkEventDate}
                          values={messages.from}
                        />
                      </ErrorMessage>
                    </Validate>
                  </div>
                  <div className={'form-group col-sm-6'}>
                    <Validate
                      name="toDateForBurial"
                      validators={[required]}
                      group={this.validatorGroup}
                      addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                      validChangeInGroup={this.validatorGroup.validChangeInGroup}
                      validationCounter={this.state.validationCounter}
                      validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                      defaultValue={toDateForBurial}
                      fieldName={messages.to}
                    >
                      <DatePicker
                        position={'bottom-start'}
                        disabled={isReadOnly}
                        name="toDateForBurial"
                        type="text"
                        onDayChange={this.handleDayChange('form.toDateForBurial')}
                        value={toDateForBurial}
                      />
                      <ErrorMessage for="required">
                        <FormattedMessage
                          {...messages.isRequired}
                          values={messages.to}
                        />
                      </ErrorMessage>
                    </Validate>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="nameOfFuneralServiceProviderForBurial"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={nameOfFuneralServiceProviderForBurial}
                fieldName={messages.nameOfFuneralServiceProvider}
              >
                <Textbox
                  name="nameOfFuneralServiceProviderForBurial"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.nameOfFuneralServiceProviderForBurial')}
                  value={nameOfFuneralServiceProviderForBurial}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.nameOfFuneralServiceProvider}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-6'}>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="costOfLocalBurialForBurial"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={costOfLocalBurialForBurial}
                fieldName={messages.costOfLocalBurial}
              >
                <Textbox
                  name="costOfLocalBurialForBurial"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChangeAmount('form.costOfLocalBurialForBurial')}
                  value={costOfLocalBurialForBurial}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.costOfLocalBurial}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="costOfLocalBurialCurrencyForBurial"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={costOfLocalBurialCurrencyForBurial}
                fieldName={messages.currency}
              >
                <CurrencySelector
                  name="costOfLocalBurialCurrencyForBurial"
                  disabled={isReadOnly}
                  value={costOfLocalBurialCurrencyForBurial}
                  onChange={this.handleCurrencyChange('form.costOfLocalBurialCurrencyForBurial')}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.currency}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="invoiceForBurial"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={invoiceForBurial}
                fieldName={messages.invoiceNumber}
              >
                <Textbox
                  name="invoiceForBurial"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.invoiceForBurial')}
                  value={invoiceForBurial}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.invoiceNumber}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-6'}>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="amountClaimedForBurial"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={amountClaimedForBurial}
                fieldName={messages.amountClaimed}
              >
                <Textbox
                  name="amountClaimedForBurial"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChangeAmount('form.amountClaimedForBurial')}
                  value={amountClaimedForBurial}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.amountClaimed}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="amountClaimedCurrency"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={amountClaimedCurrencyForBurial}
                fieldName={messages.currency}
              >
                <CurrencySelector
                  name="amountClaimedCurrencyForBurial"
                  disabled={isReadOnly}
                  value={amountClaimedCurrencyForBurial}
                  onChange={this.handleCurrencyChange('form.amountClaimedCurrencyForBurial')}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.currency}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="familyMemberProvidingInformationForBurial"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={familyMemberProvidingInformationForBurial}
                fieldName={messages.familyMemberProvidingInformation}
              >
                <Textbox
                  name="familyMemberProvidingInformationForBurial"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.familyMemberProvidingInformationForBurial')}
                  value={familyMemberProvidingInformationForBurial}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.familyMemberProvidingInformation}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="relationshipToMemberForBurial"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={relationshipToMemberForBurial}
                fieldName={messages.relationshipToMember}
              >
                <Textbox
                  name="relationshipToMemberForBurial"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.relationshipToMemberForBurial')}
                  value={relationshipToMemberForBurial}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.relationshipToMember}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-12'}>
              <Validate
                name="addressForBurial"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={addressForBurial}
                fieldName={messages.address}
              >
                <Textbox
                  name="addressForBurial"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.addressForBurial')}
                  value={addressForBurial}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.address}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-4'}>
              <Validate
                name="cityOrTownForBurial"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={cityOrTownForBurial}
                fieldName={messages.cityOrTown}
              >
                <Textbox
                  name="cityOrTownForBurial"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.cityOrTownForBurial')}
                  value={cityOrTownForBurial}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.cityOrTown}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-4'}>
              <Validate
                name="countryForBurial"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={countryForBurial}
                fieldName={messages.country}
              >
                <Textbox
                  name="countryForBurial"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.countryForBurial')}
                  value={countryForBurial}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.country}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-4'}>
              <Validate
                name="postalCodeForBurial"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={postalCodeForBurial}
                fieldName={messages.postalCode}
              >
                <Textbox
                  name="postalCodeForBurial"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChange('form.postalCodeForBurial')}
                  value={postalCodeForBurial}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.postalCode}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
          <div className={'row'}>
            <div className={'form-group col-sm-6'}>
              <Validate
                name="phoneNumberForBurial"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={phoneNumberForBurial}
                fieldName={messages.phoneNumber}
              >
                <Textbox
                  name="phoneNumberForBurial"
                  type="text"
                  disabled={isReadOnly}
                  onChange={this.handleChangePhoneNumber('form.phoneNumberForBurial')}
                  value={phoneNumberForBurial}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.phoneNumber}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'form-group col-sm-6'}>
            </div>
          </div>
        </div>
      )
    );
  }

  // Other SCTI
  renderPersonalLiabilityItems() {
    const { infoPersonalLiabilityItems = [] } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoPersonalLiabilityItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onPersonalLiabilityChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderPersonalLiability() {
    return (
      <div>
        {this.renderPersonalLiabilityItems()}
      </div>
    );
  }

  renderLossOfIncomeItems() {
    const { infoLossOfIncomeItems = [] } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoLossOfIncomeItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onLossOfIncomeChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderLossOfIncome() {
    const { dateYouWereOriginallyDueBackAtWork } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, policyTypeCode } = this.props;
    const isReadOnly = submitted || isSummary;
    const showDateYouWereOgriginallyDueBackAtWork = policyTypeCode === POLICY_TYPE.INTERNATIONAL_COMPREHENSIVE_PI || policyTypeCode === POLICY_TYPE.DOMESTIC_PI
    return (
      <div>
        {showDateYouWereOgriginallyDueBackAtWork && (<div className={'form-group col-sm-6'}>
          <PageSectionHeader>
            <FormattedMessage {...messages.dateYouWereOriginallyDueBackAtWork} />
          </PageSectionHeader>
          <DatePicker
            position={'bottom-start'}
            disabled={isReadOnly}
            name="dateYouWereOriginallyDueBackAtWork"
            type="text"
            onDayChange={this.handleDayChange('form.dateYouWereOriginallyDueBackAtWork')}
            value={dateYouWereOriginallyDueBackAtWork}
          />
        </div>
      )}
        {this.renderLossOfIncomeItems()}
      </div>
    );
  }

  renderTotalPermanentDisablementItems() {
    const { infoTotalPermanentDisablementItems = [] } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoTotalPermanentDisablementItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onTotalPermanentDisablementChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderTotalPermanentDisablement() {
    return (
      <div>
        {this.renderTotalPermanentDisablementItems()}
      </div>
    );
  }

  renderLossOfLifeItems() {
    const { infoLossOfLifeItems = [] } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoLossOfLifeItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onLossOfLifeChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderLossOfLife() {
    return (
      <div>
        {this.renderLossOfLifeItems()}
      </div>
    );
  }

  renderPersonalAccidentItems() {
    const { infoPersonalAccidentItems = [] } = this.props.form;
    const newMedicalExpenseItems = this.appendIds(infoPersonalAccidentItems);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div>
        <AdditionalList
          data={newMedicalExpenseItems}
          onChange={this.onPersonalAccidentChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderClaimingOption = () => {
    const { isSummary, submitted, policyTypeCode } = this.props;
    const {
      isThereAnyThingElseYouWouldLikeToClaimFor,
      areYouClaimingForPersonalLiability,
      personalLiabilitiesExpensesClaimed,
      personalLiabilitiesClaimDetail,
      anythingElse,
      anythingElseExpensesClaimed,
      areYouClaimingForAccidentalDeathAndDismemberment,
      areYouClaimingForRepatriationExpenses,
      areYouClaimingForBurialExpenses,
      whatExpensesAreYouClaimingFor,
      whatAreYourExpensesRelatedTo,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const isReadOnly = submitted || isSummary;
    const { validationCounter } = this.state;
    const isRenderAreYouClaimingForPersonalLiability = !!stepOtherExpenseLookup.areYouClaimingForPersonalLiability.claimCode;
    const isRenderIsThereAnyThingElseYouWouldLikeToClaimFor = !!stepOtherExpenseLookup.isThereAnyThingElseYouWouldLikeToClaimFor.claimCode;
    const isRenderAreYouClaimingForAccidentalDeathAndDismemberment = !!stepOtherExpenseLookup.areYouClaimingForAccidentalDeathAndDismemberment.claimCode;
    const isRenderAreYouClaimingForBurialOrRepatriationExpenses = !!stepOtherExpenseLookup.areYouClaimingForRepatriationExpenses.claimCode;
    const isRenderAreYouClaimingForBurialExpenses = !!stepOtherExpenseLookup.areYouClaimingForBurialExpenses.claimCode;
    // Other SCTI
    const policyTypeVisitingNZ = ['VISIT-NZ', 'VISIT-NZ-WLP001'];
    const isVisitingNewZealand = policyTypeVisitingNZ.includes(policyTypeCode);
    const isPartnerInsuranceInternationalMedicalOnlyNZ = policyTypeCode === 'INT-MED-WLP001';
    const isDomesticAu = policyTypeCode === 'DOM-AU';
    const isInternationalStudent = policyTypeCode === 'INT-ST-NZ';
    const isDomesticAUandInternationalStudent = isDomesticAu || isInternationalStudent;
    const isRenderPersonalLiability = !!stepOtherExpenseLookup.personalLiability.claimCode;
    const isRenderPersonalAccident = !!stepOtherExpenseLookup.personalAccident.claimCode;
    const isRenderLossOfIncome = !!stepOtherExpenseLookup.lossOfIncome.claimCode && !isPartnerInsuranceInternationalMedicalOnlyNZ;
    const isRenderTotalPermanentDisablement = !!stepOtherExpenseLookup.totalPermanentDisablement.claimCode && !isPartnerInsuranceInternationalMedicalOnlyNZ;
    const isRenderLossOfLife = !!stepOtherExpenseLookup.lossOfLife.claimCode;
    const isOtherSCTI = isRenderPersonalLiability || isRenderPersonalAccident || isRenderLossOfIncome || isRenderTotalPermanentDisablement || isRenderLossOfLife;
    const expensesPersonalLiabilitySelected = !!whatExpensesAreYouClaimingFor && typeof whatExpensesAreYouClaimingFor.toJS === 'function'
      ? whatExpensesAreYouClaimingFor.toJS()
      : whatExpensesAreYouClaimingFor || [];
    const expensesPersonalAccidentSelected = !!whatAreYourExpensesRelatedTo && typeof whatAreYourExpensesRelatedTo.toJS === 'function'
      ? whatAreYourExpensesRelatedTo.toJS()
      : whatAreYourExpensesRelatedTo || [];
    return (
      <div>
        {isRenderAreYouClaimingForAccidentalDeathAndDismemberment && <div className="row">
          <div className="form-group col-12">
            <PageSectionHeader>
              <FormattedMessage
                {...messages.areYouClaimingForAccidentalDeathAndDismemberment}
              />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={areYouClaimingForAccidentalDeathAndDismemberment === 'true'}
                  onChange={this.onChange(
                    'areYouClaimingForAccidentalDeathAndDismemberment'
                  )}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={areYouClaimingForAccidentalDeathAndDismemberment === 'false'}
                  onChange={this.onChange(
                    'areYouClaimingForAccidentalDeathAndDismemberment'
                  )}
                  onClick={() => {
                    this.props.onResetFormAccidentalDeathAndDismemberment();
                  }}
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>}
        {areYouClaimingForAccidentalDeathAndDismemberment === 'true' && this.renderYouClaimingForAccidentalDeathAndDismemberment()}
        {isRenderAreYouClaimingForBurialOrRepatriationExpenses && <div className="row">
          <div className="form-group col-12">
            <PageSectionHeader>
              <FormattedMessage
                {...messages.areYouClaimingForRepatriationExpenses}
              />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={areYouClaimingForRepatriationExpenses === 'true'}
                  onChange={this.onChange(
                    'areYouClaimingForRepatriationExpenses'
                  )}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={areYouClaimingForRepatriationExpenses === 'false'}
                  onChange={this.onChange(
                    'areYouClaimingForRepatriationExpenses'
                  )}
                  onClick={() => {
                    this.props.onResetFormRepatriationExpenses();
                  }}
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>}
        {areYouClaimingForRepatriationExpenses === 'true' && this.renderYouClaimingForRepatriationExpenses()}
        {isRenderAreYouClaimingForBurialExpenses && <div className="row">
          <div className="form-group col-12">
            <PageSectionHeader>
              <FormattedMessage
                {...messages.areYouClaimingForBurialExpenses}
              />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={areYouClaimingForBurialExpenses === 'true'}
                  onChange={this.onChange(
                    'areYouClaimingForBurialExpenses'
                  )}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={areYouClaimingForBurialExpenses === 'false'}
                  onChange={this.onChange(
                    'areYouClaimingForBurialExpenses'
                  )}
                  onClick={() => {
                    this.props.onResetFormBurialExpenses();
                  }}
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>}
        {areYouClaimingForBurialExpenses === 'true' && this.renderYouClaimingForBurialExpenses()}
        {isRenderAreYouClaimingForPersonalLiability && areYouClaimingForPersonalLiability === 'true' && (
          <div className="ml-4">
            <ExpenseClaimForm
              {...this.props}
              handleChange={this.handleChange}
              validatorGroup={this.validatorGroup}
              onChange={this.onChange}
              onExpansesClaimedChange={this.onExpansesClaimedChange}
              expensesClaimed={personalLiabilitiesExpensesClaimed}
              expenseName="personalLiabilitiesExpensesClaimed"
              validationCounter={validationCounter}
              isReadOnly={isReadOnly}
              claimDetail={personalLiabilitiesClaimDetail}
              exenseDetailName="personalLiabilitiesClaimDetail"
              expenseType={1}
              isSummary={isSummary}
            />
          </div>
        )}

        {isRenderIsThereAnyThingElseYouWouldLikeToClaimFor && <div className="row">
          <div className="form-group col-12">
            <PageSectionHeader>
              <FormattedMessage
                {...messages.isThereAnyThingElseYouWouldLikeToClaimFor}
              />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={isThereAnyThingElseYouWouldLikeToClaimFor === 'true'}
                  onChange={this.onChange(
                    'isThereAnyThingElseYouWouldLikeToClaimFor'
                  )}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={isThereAnyThingElseYouWouldLikeToClaimFor === 'false'}
                  onChange={this.onChange(
                    'isThereAnyThingElseYouWouldLikeToClaimFor'
                  )}
                  onClick={() => {
                    this.props.resetBenefitOther();
                  }
                  }
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>}
        {isRenderIsThereAnyThingElseYouWouldLikeToClaimFor && isThereAnyThingElseYouWouldLikeToClaimFor === 'true' && (
          <div className="ml-4">
            <ExpenseClaimForm
              {...this.props}
              handleChange={this.handleChange}
              validatorGroup={this.validatorGroup}
              onChange={this.onChange}
              onExpansesClaimedChange={this.onExpansesClaimedChange}
              expensesClaimed={anythingElseExpensesClaimed}
              expenseName="anythingElseExpensesClaimed"
              validationCounter={validationCounter}
              isReadOnly={isReadOnly}
              claimDetail={anythingElse}
              exenseDetailName="anythingElse"
              expenseType={4}
            />
          </div>
        )}

        {isOtherSCTI && (
          <Validate
            name="whatExpensesAreYouClaimingFor"
            validators={[required]}
            group={this.validatorGroup}
            addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
            validChangeInGroup={this.validatorGroup.validChangeInGroup}
            validationCounter={this.state.validationCounter}
            validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
            defaultValue={expensesPersonalLiabilitySelected}
            fieldName={messages.whatExpensesAreYouClaimingFor}
          >
            <div className={'row'}>
              {isRenderPersonalLiability && (<div className="pt-2 col-sm-12 form-group">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Personal Liability"
                  checked={expensesPersonalLiabilitySelected.includes('Personal Liability')}
                  onChange={this.handlePersonalLiabilityExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.personalLiability} />
                </span>
                {expensesPersonalLiabilitySelected.includes('Personal Liability') && (
                  <div>
                    <div className={'col-sm-12 form-group'}>
                      <PageSectionHeader>
                        <FormattedMessage {...messages.personalLiabilityMessage} />
                      </PageSectionHeader>
                    </div>
                    <div className="col-sm-12 form-group">
                      {this.renderPersonalLiability()}
                    </div>
                  </div>
                )}
              </div>)}
              {isRenderPersonalAccident && (<div className="col-sm-12 form-group">
                <input
                  disabled={isReadOnly}
                  type="checkbox"
                  name="Personal Accident"
                  checked={expensesPersonalLiabilitySelected.includes('Personal Accident')}
                  onChange={this.handlePersonalLiabilityExpensesSelected('form.whatExpensesAreYouClaimingFor')}
                />
                <span>
                  <FormattedMessage {...messages.personalAccident} />
                </span>
                {expensesPersonalLiabilitySelected.includes('Personal Accident') && (
                  <div>
                    {isVisitingNewZealand &&
                      <div className="ml-2 row">
                        <div className={'col-sm-12 form-group'} style={{ paddingTop: '10px' }}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.thisSectionIsForClaimsRelatedToLossOfLifeCausedByAnInjury} />
                          </PageSectionHeader>
                          {this.renderPersonalAccidentItems()}
                        </div>
                      </div>
                    }
                    {!isVisitingNewZealand &&
                      <div>
                        <div className={'col-sm-12 form-group'}>
                          <PageSectionHeader>
                            {isDomesticAUandInternationalStudent ? (
                              <FormattedMessage
                                {...messages.personalAccidentHeadersOnDomesticAUAndInternationalStudent}
                              />
                            ) : isPartnerInsuranceInternationalMedicalOnlyNZ ? (
                              <FormattedMessage
                                {...messages.personalAccidentParnerInsuranceInternationalMedicalOnlyNZMessage}
                              />
                            ) : (
                              <FormattedMessage
                                {...messages.personalAccidentMessage}
                              />
                            )}
                          </PageSectionHeader>
                        </div>
                        <div className={'col-sm-12 form-group'}>
                          <PageSectionHeader>
                            <FormattedMessage {...messages.whatAreYourExpensesRelatedTo} />
                          </PageSectionHeader>
                        </div>
                        <div className="col-sm-12 form-group">
                          {isRenderLossOfIncome && (<div className="col-sm-12 form-group">
                            <input
                              disabled={isReadOnly}
                              type="checkbox"
                              name="Loss of Income"
                              checked={expensesPersonalAccidentSelected.includes('Loss of Income')}
                              onChange={this.handlePersonalAccidentExpensesSelected('form.whatAreYourExpensesRelatedTo')}
                            />
                            <span>
                              <FormattedMessage {...messages.lossOfIncome} />
                            </span>
                            {expensesPersonalAccidentSelected.includes('Loss of Income') && (
                              <div>
                                <div className="col-sm-12 form-group">
                                  {this.renderLossOfIncome()}
                                </div>
                              </div>
                            )}
                          </div>)}
                          {isRenderTotalPermanentDisablement && (<div className="col-sm-12 form-group">
                            <input
                              disabled={isReadOnly}
                              type="checkbox"
                              name="Total permanent disablement"
                              checked={expensesPersonalAccidentSelected.includes('Total permanent disablement')}
                              onChange={this.handlePersonalAccidentExpensesSelected('form.whatAreYourExpensesRelatedTo')}
                            />
                            <span>
                              <FormattedMessage {...messages.totalPermanentDisablement} />
                            </span>
                            {expensesPersonalAccidentSelected.includes('Total permanent disablement') && (
                              <div>
                                <div className="col-sm-12 form-group">
                                  {this.renderTotalPermanentDisablement()}
                                </div>
                              </div>
                            )}
                          </div>)}
                          {isRenderLossOfLife && (<div className="col-sm-12 form-group">
                            <input
                              disabled={isReadOnly}
                              type="checkbox"
                              name="Loss of Life"
                              checked={expensesPersonalAccidentSelected.includes('Loss of Life')}
                              onChange={this.handlePersonalAccidentExpensesSelected('form.whatAreYourExpensesRelatedTo')}
                            />
                            <span>
                              <FormattedMessage {...messages.lossOfLife} />
                            </span>
                            {expensesPersonalAccidentSelected.includes('Loss of Life') && (
                              <div>
                                <div className="col-sm-12 form-group">
                                  {this.renderLossOfLife()}
                                </div>
                              </div>
                            )}
                          </div>)}
                        </div>
                      </div>
                    }
                  </div>
                )}
              </div>)}
            </div>
            <ErrorMessage for="required">
              <FormattedMessage
                {...messages.isRequired}
                values={messages.whatExpensesAreYouClaimingFor}
              />
            </ErrorMessage>
          </Validate>
        )}
      </div>
    );
  };

  render() {
    const { isSummary, submitted, loading } = this.props;
    // const isReadOnly = submitted || isSummary;
    return (
      <div className="app-content">
        {this.renderClaimingOption()}
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="base-button back-button"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

StepOther.propTypes = {
  sendPhysicianEmail: PropTypes.func,
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  errors: PropTypes.any,
  loading: PropTypes.bool,
  currentStep: PropTypes.number,
  step: PropTypes.number,
  adjust: PropTypes.func,
  onNext: PropTypes.func,
  makeError: PropTypes.func,
  makeValid: PropTypes.func,
  isReadOnly: PropTypes.bool,
  resetBenefitOther: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  onResetFormAccidentalDeathAndDismemberment: PropTypes.func,
  onResetFormRepatriationExpenses: PropTypes.func,
  onResetFormBurialExpenses: PropTypes.func,
  onResetFormPersonalLiability: PropTypes.func,
  onResetFormPersonalAccident: PropTypes.func,
  onResetFormLossOfIncome: PropTypes.func,
  onResetFormTotalPermanentDisablement: PropTypes.func,
  onResetFormLossOfLife: PropTypes.func,
  jsonVersion: PropTypes.string,
  insuredsList: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
  policyTypeCode: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStepOther(),
  errors: makeSelectStepOtherErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  jsonVersion: makeSelectJSONVersion(),
  insuredsList: makeSelectInsuredsList(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
  policyTypeCode: makeSelectPolicyTypeCode(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) =>
    dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onReset: () => dispatch(resetFormData()),
  onResetFormAccidentalDeathAndDismemberment: () => dispatch(resetFormAccidentalDeathAndDismemberment()),
  onResetFormRepatriationExpenses: () => dispatch(resetFormRepatriationExpenses()),
  onResetFormBurialExpenses: () => dispatch(resetFormBurialExpenses()),
  resetSubBenefit: () => dispatch(resetSubBenefit()),
  resetBenefitOther: () => dispatch(resetBenefitOther()),
  sendPhysicianEmail: () => dispatch(emailMedicalADDDocument()),
  onResetFormPersonalLiability: () => dispatch(resetFormPersonalLiability()),
  onResetFormPersonalAccident: () => dispatch(resetFormPersonalAccident()),
  onResetFormLossOfIncome: () => dispatch(resetFormLossOfIncome()),
  onResetFormTotalPermanentDisablement: () => dispatch(resetFormTotalPermanentDisablement()),
  onResetFormLossOfLife: () => dispatch(resetFormLossOfLife()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({
  key: 'stepOther',
  reducer,
});

export default compose(
  withReducer,
  withConnect
)(StepOther);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepOther/index.js